import { DateTime } from 'luxon';

import { PaymentPlans, pharmacyBillingSelector } from '@pharmaplan/common';

import { MomentTimeFormats } from '../../helpers/Constants';
import { useAppSelector } from '../useAppSelector';
import strings from '../../localization';

const useExistingPaymentPlanDates = () => {
  const planDetails = useAppSelector(pharmacyBillingSelector);

  const { currentPlan, renewalDate, activeUntil } = planDetails;
  const isUnlimited = currentPlan?.toLowerCase() === PaymentPlans.unlimited;
  const isTerminatedPlan = !renewalDate && isUnlimited;

  const getDate = () => {
    if (isTerminatedPlan) {
      const validTillDate = DateTime.fromISO(activeUntil ?? '', {
        setZone: true,
      });
      return {
        label: strings.planWillTerminate,
        renewal: validTillDate
          .plus({ day: 1 })
          .toFormat(MomentTimeFormats.dateMonthYear),
        validUntil: validTillDate.toFormat(MomentTimeFormats.dateMonthYear),
      };
    }

    if (isUnlimited) {
      const date = DateTime.fromISO(activeUntil ?? renewalDate, {
        setZone: true,
      });
      return {
        label: strings.planIsActiveTillFormat,
        renewal: date.plus({ day: 1 })
          .toFormat(MomentTimeFormats.dateMonthYear),
        validUntil: date
          .toFormat(MomentTimeFormats.dateMonthYear),
      };
    }

    return {
      renewal: '',
      validUntil: '',
    };
  };

  return getDate();
};

export default useExistingPaymentPlanDates;
